module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Dosser’s Dreams")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004"
    }
  }, [_vm._v("Rover is in the Huff")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005"
    }
  }, [_vm._v("“If You Weren’t a Fucking Woman, I’d Bite Your Fucking Tits Aff.”")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#you-are-skint"
    }
  }, [_vm._v("You are skint")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#lockdown"
    }
  }, [_vm._v("Lockdown")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006"
    }
  }, [_vm._v("Pouring")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#the-stench-is-appalling"
    }
  }, [_vm._v("The stench is appalling")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rat-arsed")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Collected Thoughts of Two Amputated Brains")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Always Wanted to Commit Suicide")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Problem with the Coffee Kitty")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Happy Encounters")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#i-just-gobbed-him",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I just gobbed him")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waiting on the Perfect Job Ad")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aspects of Being an Asshole")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#gum-shoes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gum shoes")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You Can’t Win Them All")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prices")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Decision")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It Is Forbidden to Play the Trumpet Underneath the Kitchen Table")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Disappointment")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Duck Race")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Laurie’s Valentine’s Day Card")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Ideal Partner")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Planned Commitments")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Treat a Woman Right?")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I’m Not Afraid of the Dark")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Hector and the Brother-in-Law")])])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Lawyer Is Sending Me to Prison")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("’The Life of a Drinker Is Not an Easy One")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Why I Am Not a Vampire")])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Why All My Womenfolk Are Either Dead or in the Nuthouse")])]), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wrong Track")])]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Side Street Walking")])]), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Unsolicited Amputation")])]), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tales of Dragons and Invisible Pussy Cats")])]), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Life and Times of a Born Wanker")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0